import React, { ComponentProps } from 'react';
import IUrl, { ISonURL } from '../../../types/IUrl';
import { ProfileImageSmall } from '../../../types/api/ImageType';
import { asView } from '../../../_lib/ViewFetcher';
import { ContentList, ContentListItem } from '../../../_lib/components/ContentList';
import { ContactPerson } from '../../../_lib/components/ContactPerson';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type ConnectedUserRole = {
  id: string;
  name: string;
  roleId: string;
  orderKey: number;
};
export type ConnectedUser = {
  userId: string;
  profileName: string;
  profileLink: ISonURL;
  personInfoCardUrl: IUrl;
  phoneLink: ISonURL;
  emailLink?: ISonURL;
  role: ConnectedUserRole;
  profileImageUrl: ProfileImageSmall;
};
type ConnectedUsersDefaultProps = {
  users: ConnectedUser[];
};

function ConnectedUserDefault({ users }: ConnectedUsersDefaultProps) {
  const { t } = useSonTranslation('ConnectedUsers');

  if (users && users.length === 0) {
    return <ContentMessage text={t('noUsers')} />;
  }

  return (
    <ContentList>
      {users.map(({ role, ...user }) => (
        <ContentListItem key={user.userId}>
          <ContactPerson {...user} roleNames={[role.name]} />
        </ContentListItem>
      ))}
    </ContentList>
  );
}

export const ConnectedUsersDefaultView = asView(ConnectedUserDefault);
export type ConnectedUsersDefaultView = ComponentProps<typeof ConnectedUsersDefaultView>;
